var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('meetingHeader',{attrs:{"title":'会议预定',"right-show":false}}),_c('MeetingFrom',{attrs:{"meeting-data":_vm.meetingData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }